import React, { Component } from "react";
import NavigationComponents from "../../Components/Navigation/Navigation";
import NoAccess from "../../Components/NoAccess";
import { MsalContext } from "@azure/msal-react";
import { Navigate } from "react-router-dom";
import Loader from "../../Components/Shared/Loader/loader";

export class NoAccessPage extends Component {
    static contextType = MsalContext;
    constructor(props) {
        super(props);
        let organizationResult = this.props.organizations.filter((org) => org.number === this.props.orgName);
        let isOwnerofOrg = this.props.organizations.findIndex((org) => org.roleType === "Owner") > -1;
        let createOrg = [
            {
                id: "Create_Org",
                number: "CreateOrg",
            },
        ];
        let orgs = isOwnerofOrg ? this.props.organizations : [...this.props.organizations, ...createOrg];

        this.state = {
            user: { ...this.props.user },
            organizations: orgs,
            selectedOrg: organizationResult[0],
        };
    }
    render() {
        let { context } = this;

        if (context.inProgress !== "none") {
            return <Loader />;
        }

        if (context.accounts.length === 0) {
            return <Navigate to="/" />;
        }
        return (
            <>
                <NavigationComponents
                    user={this.props.user}
                    hideInviteButton={true}
                    userRole={this.props.userRole}
                    OrgName={this.props.org_id}
                    organizations={this.state.organizations}
                    selectedOrg={this.props.organizations.filter((org) => org.number === this.props.orgName)[0]}
                >
                </NavigationComponents>
                <NoAccess/>
            </>
        );
    }
}
